import Http from '@/api/http.js'

export default {

  index(filters) {
    return Http.get(`/pay_devolutions`, {params: {...filters}})
  },
  show(id) {
    return Http.get(`/pay_devolutions/${id}`);
  },
  
  // create(pay_devolutions){
  //   return Http.post(`/pay_devolutions`, {pay_devolutions: {...pay_devolutions}})
  // },

  // update(pay_devolutions){
  //   return Http.put(`/pay_devolutions/${pay_devolutions.id}`, {
  //     pay_devolutions: {...pay_devolutions},
  //   });
  // },

}
